import { render, staticRenderFns } from "./el-checkbox.vue?vue&type=template&id=6f37d475&scoped=true"
import script from "./el-checkbox.vue?vue&type=script&lang=js"
export * from "./el-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f37d475",
  null
  
)

export default component.exports